// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__cDyLr","title":"Header_title__2f6RE","side":"Header_side__OpASU"};